import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import TenantContractContextWrapper from "@eres/ejari-core/contexts/TenantContractContext";
import { Route, Switch } from "react-router";
import TenantRequestDetails from "./TenantRequestDetails";
import EditTenantContract from "../../TenantContract/Edit";

class TenantRequestDetail extends Component<RoutedViewProps> {
	render() {
		const pp = this.props.match.url;
		return <TenantContractContextWrapper>
			<Switch>
				<Route path={ pp + "/edit" } component={ EditTenantContract }/>
				<Route path={ pp } render={ () => <TenantRequestDetails { ...this.props }/> }/>
			</Switch>
		</TenantContractContextWrapper>;
	}
}

export default TenantRequestDetail;
